import { m8API } from 'services/production/m8';
import { normalizeM8PaymentTransactionDTO } from 'services/production/utils/normalizeM8PaymentTransactionDTO';
import { GetCardPaymentsPageDataService } from 'types/services';
import { normalizeCardPaymentsTableSortableField } from 'services/production/utils/normalizeCardPaymentsTableSortableField';

export const getCardPaymentsPageData: GetCardPaymentsPageDataService = async (
  params
) => {
  const order = (() => {
    if (params.sorting.field === 'status') {
      return params.sorting.ascending ? 'DESC' : 'ASC';
    } else {
      return params.sorting.ascending ? 'ASC' : 'DESC';
    }
  })();

  const data = await m8API.admin.getPaymentTransactions({
    page: params.page - 1,
    size: params.pageSize,
    order,
    sort: normalizeCardPaymentsTableSortableField(
      params.sorting.field
    ).toM8PaymentTransactionDTOSortableField(),
    startWith: params.searchBy || '',
  });

  if (data) {
    const payments = data.content.map((content) =>
      normalizeM8PaymentTransactionDTO(content).toCardPayment()
    );

    return {
      totalPagesCount: data.totalPages,
      payments,
    };
  }

  return {
    totalPagesCount: 0,
    payments: [],
  };
};
